module.exports = __webpack_public_path__ + "static/media/Value-Based Selling.17338832.pdf";